import { Directive, HostListener, inject } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { StorageService, StorageType } from "gast-common-ng2";

@Directive({
  selector: "a[portalAnchorExternalUrl]",
  standalone: true,
})
export class ExternalUrlDirective {
  readonly #storageService = inject(StorageService);
  readonly #route = inject(ActivatedRoute);

  @HostListener("click", ["$event"])
  clicked() {
    const queryParams = JSON.parse(JSON.stringify(this.#route.snapshot.queryParams));
    // TODO: determine the behavior for other portal
    // currently only duo query param will be set in cookie when external url is clicked
    if (!this.#isEmpty(queryParams)) {
      delete queryParams.lang;
      console.log("save params to cookie: " + JSON.stringify(queryParams));
      this.#storageService.setItem("duo-url-params", JSON.stringify(queryParams), StorageType.Session);
    }
  }

  /**
   * Check if object empty
   * @param obj
   */
  #isEmpty(obj: object): boolean {
    for (const prop in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        return false;
      }
    }
    return true;
  }
}
